// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the Constants.tst template. 
// !!Do not modify this file or change may be lost!!
/* eslint-disable */
export default class DrsfaPurposes {
    public static readonly ADVOCATECANDIDATE: string = 'Advocate for/against candidate(s)';
    public static readonly BALLOTFOR: string = 'Advocate for ballot issue(s)';
    public static readonly BALLOTAGAINST: string = 'Advocate against ballot issue(s)';
}
